import { createApp, ref } from "vue";
import App from "./App.vue";
import "./assets/main.css";
import "bottom-sheet-vue3/css/style.css";
import "sweetalert2/dist/sweetalert2.min.css";
import router from "./router";
import store from "./store";
import helper from "@/utils/helper";
import VueSweetalert2 from "vue-sweetalert2";
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { NeshanMapLeaflet } from "vuejs-neshan-map-leaflet";

import {
  faPhoneFlip,
  faClock,
  faLocationDot,
  faHouse,
  faBars,
  faUser,
  faCartShopping,
  faBuilding,
  faRightFromBracket,
  faDesktop,
  faCreditCard,
  faTable,
  faUsers,
  faFileSignature,
  faArrowTurnUp,
  faMoneyBill,
  faUserGroup,
  faRectangleList,
} from "@fortawesome/free-solid-svg-icons";

import './registerServiceWorker'
library.add(
  faPhoneFlip,
  faClock,
  faLocationDot,
  faHouse,
  faBars,
  faUser,
  faCartShopping,
  faBuilding,
  faRightFromBracket,
  faDesktop,
  faCreditCard,
  faTable,
  faUsers,
  faFileSignature,
  faArrowTurnUp,
  faMoneyBill,
  faUserGroup,
  faRectangleList
);

const app = createApp(App);
app.config.globalProperties.$loading = ref(false);
app.config.globalProperties.$modal = ref(false);
app.config.globalProperties.$cart = ref(false);
app.config.globalProperties.$contact = ref(false);
app.config.globalProperties.$modalLogin = ref(false);

app
  .use(store)
  .use(router)
  .use(helper)
  .use(VueSweetalert2)
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(NeshanMapLeaflet)
  .use(Vue3PersianDatetimePicker, {
    name: "CustomDatePicker",
    props: {
      format: "jYYYY/jMM/jDD",
      displayFormat: "jYYYY/jMM/jDD",
      editable: false,
      inputClass: "datepicker",
      placeholder: "لطفا یک تاریخ انتخاب کنید",
      altFormat: "YYYY/MM/DD",
      color: "#FFA500",
      autoSubmit: false,
    },
  })
  .mount("#app");

export default app;
